import domContentLoaded from 'dom-content-loaded';
import { throttle } from 'throttle-debounce';
import $ from 'jquery';

domContentLoaded(() => {
	/* メインイメージのアニメーション用 */
	const $window = $(window);
	const $mv = $('.js_mv');
	$window.on('load', () => {
		$mv.addClass('is_loaded');
	});
});
